import { Component, Input } from '@angular/core';
import { HvtSection1ContactDto } from '../../../models/notices/ojeu.notice.models';

@Component({
    selector: 'hvt-s1-contact',
    template: require('./hvt.section.1.contact.component.html')
})
export class HvtSection1ContactComponent {
    @Input() contact: HvtSection1ContactDto;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.1.contact.component.ts